import { render, staticRenderFns } from "./qrcode-link.vue?vue&type=template&id=ddeb14c4&scoped=true"
import script from "./qrcode-link.vue?vue&type=script&lang=js"
export * from "./qrcode-link.vue?vue&type=script&lang=js"
import style0 from "./qrcode-link.vue?vue&type=style&index=0&id=ddeb14c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../A8/pc/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeb14c4",
  null
  
)

export default component.exports